import { api } from "../../../api/apiSlice";

export const holidaysApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHolidays: builder.query({
      query: () => ({ url: "/masters/holidays" }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((h) => ({ type: "HrHolidays", id: h.id })),
              { type: "HrHolidays", id: "LIST" },
            ]
          : [{ type: "HrHolidays", id: "LIST" }],
    }),
    createHoliday: builder.mutation({
      query: (body) => ({ url: "/masters/holidays", method: "POST", data: body }),
      invalidatesTags: [{ type: "HrHolidays", id: "LIST" }],
    }),
    updateHoliday: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/masters/holidays/${id}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: [{ type: "HrHolidays", id: "LIST" }],
    }),
    // Holiday-aware "Yesterday" (2026-09-14): GET /masters/holidays/last-working-day
    // (Batch83, live since 2026-08-24) answers whether a date was a working day and,
    // if not, the last one before it (Sundays computed from the date itself, named
    // public holidays from holidays_master). Built for exactly this; until now only
    // the phone app called it, so every web "Yesterday" on a Monday showed Sunday.
    // Bare [Authorize] server-side - no HR permission needed. A day's answer never
    // changes, so keep it cached for the session.
    getLastWorkingDay: builder.query({
      query: (date) => ({ url: "/masters/holidays/last-working-day", params: { date } }),
      keepUnusedDataFor: 3600,
    }),
    deleteHoliday: builder.mutation({
      query: (id) => ({ url: `/masters/holidays/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "HrHolidays", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetHolidaysQuery,
  useCreateHolidayMutation,
  useUpdateHolidayMutation,
  useDeleteHolidayMutation,
  useGetLastWorkingDayQuery,
  useLazyGetLastWorkingDayQuery,
} = holidaysApi;
